import script from "./logManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./logManagement.vue?vue&type=script&setup=true&lang=js"

import "./logManagement.vue?vue&type=style&index=0&id=f7abad58&lang=scss"

const __exports__ = script;

export default __exports__